import React from 'react';

const LogoProperties = ({ block, onUpdate }) => {
    return (
        <div className="space-y-4">
            <p className="text-sm text-gray-600">Le logo est automatiquement récupéré depuis les informations du séminaire. Vous pouvez modifier son espacement ici.</p>
            <div className="pt-4 border-t">
                <label className="block text-sm font-medium">Marge haute ({block.paddingTop || 0}px)</label>
                <input type="range" min="0" max="64" value={block.paddingTop || 0} onChange={(e) => onUpdate(block.id, { paddingTop: parseInt(e.target.value) })} className="w-full" />
            </div>
            <div>
                <label className="block text-sm font-medium">Marge basse ({block.paddingBottom || 0}px)</label>
                <input type="range" min="0" max="64" value={block.paddingBottom || 0} onChange={(e) => onUpdate(block.id, { paddingBottom: parseInt(e.target.value) })} className="w-full" />
            </div>
        </div>
    );
};

export default LogoProperties;